"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.advise = void 0;
var node_fetch_1 = __importDefault(require("node-fetch"));
var evaluate_1 = require("./evaluate");
var parseAndValidate_1 = require("./parseAndValidate");
var parseReserveSummary = function (data) {
    var globalFields = [
        'height',
        'accountHealthThreshold',
        'accountHealthOverlap',
        'collapsePenalty',
    ];
    var reserveFields = [
        'price',
        'assetId',
        'aTokenId',
        'reserveAddress',
        'ABCD',
        'reserveFactor',
        'collateralFactor',
        'liquidationThreshold',
        'liquidationPenalty',
        'currentTotalDeposit',
        'storedTotalDeposit',
        'currentTotalDebt',
        'storedTotalDebt',
        'currentTotalReserve',
        'storedTotalReserve',
        'currentIndex',
        'storedIndex',
        'lastUpdateHeight',
        'utilization',
        'aTokenCirculation',
        'aTokenPrice',
        'APR',
        'APY',
    ];
    var _a = data
        .split(' ').join('')
        .split('],[').join('][')
        .split(',[').join('[')
        .split('['), globalData = _a[0], reservesData = _a.slice(1);
    return __assign(__assign({}, (0, parseAndValidate_1.parseAndValidate)()(globalData, globalFields)), { reserves: reservesData.map(function (x) {
            return x.replace(']', '');
        }).map(function (x) { return (0, parseAndValidate_1.parseAndValidate)()(x, reserveFields); }) });
};
var parseReservesSpeedsAndViresPriceData = function (data) {
    var globalFields = [
        'height',
        'viresAssetId',
        'viresPrice',
        'totalStaked',
    ];
    var reserveFields = [
        'reserveAddress',
        'depositRewardSpeed',
        'borrowRewardSpeed',
    ];
    var _a = data
        .split(' ').join('')
        .split('],[').join('][')
        .split(',[').join('[')
        .split('['), globalData = _a[0], reservesData = _a.slice(1);
    return __assign(__assign({}, (0, parseAndValidate_1.parseAndValidate)()(globalData, globalFields)), { reserveSpeeds: reservesData.map(function (x) {
            return x.replace(']', '');
        }).map(function (x) { return (0, parseAndValidate_1.parseAndValidate)()(x, reserveFields); }) });
};
var advise = function (_a) {
    var nodeApi = _a.nodeApi, evaluator = _a.evaluator, evaluator2 = _a.evaluator2, main = _a.main, _b = _a._fetch, _fetch = _b === void 0 ? node_fetch_1.default : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var func, _c, data, data2, _d, reserves, summary, _e, reserveSpeeds, viresAssetId, viresPrice, totalStaked;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    func = "advise(\"".concat(main, "\")");
                    return [4 /*yield*/, Promise.all([
                            (0, evaluate_1.evaluate)(nodeApi, evaluator, func, _fetch),
                            (0, evaluate_1.evaluate)(nodeApi, evaluator2, func, _fetch),
                        ])];
                case 1:
                    _c = _f.sent(), data = _c[0], data2 = _c[1];
                    _d = parseReserveSummary(data), reserves = _d.reserves, summary = __rest(_d, ["reserves"]);
                    _e = parseReservesSpeedsAndViresPriceData(data2), reserveSpeeds = _e.reserveSpeeds, viresAssetId = _e.viresAssetId, viresPrice = _e.viresPrice, totalStaked = _e.totalStaked;
                    return [2 /*return*/, __assign(__assign({}, summary), { viresAssetId: viresAssetId, viresPrice: viresPrice, totalViresStaked: totalStaked, reserves: reserves.map(function (r) {
                                var found = reserveSpeeds.find(function (x) { return x.reserveAddress === r.reserveAddress; });
                                return __assign(__assign({}, r), { depositRewardSpeed: (found === null || found === void 0 ? void 0 : found.depositRewardSpeed) || '0', borrowRewardSpeed: (found === null || found === void 0 ? void 0 : found.borrowRewardSpeed) || '0' });
                            }) })];
            }
        });
    });
};
exports.advise = advise;
//# sourceMappingURL=advise.js.map